<header>


</header>

@if (user) {
  <div class="navigation-container" [class.navigation-is-mobile]="isMobile()">
    <mat-toolbar>
      <!-- Logo -->
      <a class="BO9-logo"
        [class.dark]="isDarkTheme"
        [class.light]="isLightTheme"
        routerLink='/profile/Edit'>
        BO9
      </a>
      <button mat-button (click)="drawer.toggle()"><mat-icon>menu</mat-icon></button>
      Welcome {{ user.contact.names.name.first }}
      <div class="helpfooter"><button mat-stroked-button (click)="help()"><mat-icon>help_center</mat-icon></button></div>
      <div class="helpfooter"><button mat-stroked-button (click)="support()"><mat-icon>support_agent</mat-icon></button></div>
      <div class="logoutfooter"><button mat-stroked-button (click)="logout()"><mat-icon>logout</mat-icon></button></div>
    </mat-toolbar>
    <app-notify></app-notify>
    <mat-sidenav-container autosize class="navigation-sidebar-container">
      <mat-sidenav #drawer mode="side" opened role="navigation">
        @if (!isUser()) {
          <mat-nav-list>
            @if (isAdmin()) {
              <a class="sidebar-people" mat-list-item
                routerLink='/dashboard'
                routerLinkActive="sidebar-active-link">
                <mat-icon>manage_accounts</mat-icon>
                @if (!isMobile()) {
                  <span>Admin</span>
                }
              </a>
            }
            @if (isJourneyman()) {
              <a class="sidebar-dashboard" mat-list-item
                routerLink='/guild/edit'
                routerLinkActive="sidebar-active-link">
                <mat-icon>dashboard</mat-icon>
                @if (!isMobile()) {
                  <span>Dashboard</span>
                }
              </a>
            }
            @if (isAdmin()) {
              <a class="sidebar-people" mat-list-item
                routerLink='/people'
                routerLinkActive="sidebar-active-link">
                <mat-icon>group</mat-icon>
                @if (!isMobile()) {
                  <span>People</span>
                }
              </a>
            }
            @if (isMaster()) {
              <a class="sidebar-messages" mat-list-item
                routerLink='/events'
                routerLinkActive="sidebar-active-link">
                <mat-icon>event</mat-icon>
                @if (!isMobile()) {
                  <span>Event Mgr</span>
                }
              </a>
            }
            <!--
            <a class="sidebar-messages" mat-list-item *ngIf="isAdmin()"
              routerLink='/affiliates'
              routerLinkActive="sidebar-active-link">
              <mat-icon>supervised_user_circle</mat-icon>
              <span *ngIf="!isMobile()">Guild Mgr</span>
            </a>-->
            @if (isAdmin()) {
              <a class="sidebar-people" mat-list-item
                routerLink='/students'
                routerLinkActive="sidebar-active-link">
                <mat-icon>cast_for_education</mat-icon>
                @if (!isMobile()) {
                  <span>Student Mgr</span>
                }
              </a>
            }
            @if (isMaster()) {
              <a class="sidebar-pearls" mat-list-item
                routerLink='/pearls'
                routerLinkActive="sidebar-active-link">
                <mat-icon>receipt_long</mat-icon>
                @if (!isMobile()) {
                  <span>Pearls</span>
                }
              </a>
            }
            @if (isAdmin()) {
              <a class="sidebar-products" mat-list-item
                routerLink='/products'
                routerLinkActive="sidebar-active-link">
                <mat-icon>inventory_2</mat-icon>
                @if (!isMobile()) {
                  <span>Products</span>
                }
              </a>
            }
            @if (isAdmin()) {
              <a class="sidebar-messages" mat-list-item
                routerLink='/orders'
                routerLinkActive="sidebar-active-link">
                <mat-icon>shopping_basket</mat-icon>
                @if (!isMobile()) {
                  <span>Orders</span>
                }
              </a>
            }
            @if (isAdmin()) {
              <a class="sidebar-messages" mat-list-item
                routerLink='/activecampaign'
                routerLinkActive="sidebar-active-link">
                <mat-icon>email</mat-icon>
                @if (!isMobile()) {
                  <span>Act. Camp.</span>
                }
              </a>
            }
            @if (isAdmin()) {
              <a class="sidebar-messages" mat-list-item
                routerLink='/deals'
                routerLinkActive="sidebar-active-link">
                <mat-icon>attach_money</mat-icon>
                @if (!isMobile()) {
                  <span>Deals</span>
                }
              </a>
            }
            @if (isAdmin()) {
              <a class="sidebar-messages" mat-list-item
                routerLink='/credit'
                routerLinkActive="sidebar-active-link">
                <mat-icon>article</mat-icon>
                @if (!isMobile()) {
                  <span>Credit Hours</span>
                }
              </a>
            }
            @if (isAdmin()) {
              <a class="sidebar-messages" mat-list-item
                routerLink='/errors'
                routerLinkActive="sidebar-active-link">
                <mat-icon>notification_important</mat-icon>
                @if (!isMobile()) {
                  <span>Errors</span>
                }
              </a>
            }
            @if (isAdmin()) {
              <a class="sidebar-messages" mat-list-item
                routerLink='/relations'
                routerLinkActive="sidebar-active-link">
                <mat-icon>family_restroom</mat-icon>
                @if (!isMobile()) {
                  <span>Relations</span>
                }
              </a>
            }
            @if (isAdmin()) {
              <a class="sidebar-messages" mat-list-item
                routerLink='/groups'
                routerLinkActive="sidebar-active-link">
                <mat-icon>groups</mat-icon>
                @if (!isMobile()) {
                  <span>Groups</span>
                }
              </a>
            }
            <!--
            <a class="sidebar-messages" mat-list-item *ngIf="isAdmin()"
              routerLink='/movement'
              routerLinkActive="sidebar-active-link">
              <mat-icon>animation</mat-icon>
              <span *ngIf="!isMobile()">Movements</span>
            </a>
            <a class="sidebar-messages" mat-list-item *ngIf="isAdmin()"
              routerLink='/invites'
              routerLinkActive="sidebar-active-link">
              <mat-icon>drafts</mat-icon>
              <span class="sidebar-dashboard-text">Invites</span>
            </a>-->
            @if (isMaster()) {
              <a class="sidebar-messages" mat-list-item
                routerLink='/pages'
                routerLinkActive="sidebar-active-link">
                <mat-icon>pages</mat-icon>
                @if (!isMobile()) {
                  <span>Pages</span>
                }
              </a>
            }
            @if (isAdmin()) {
              <a class="sidebar-messages" mat-list-item
                routerLink='/agreements'
                routerLinkActive="sidebar-active-link">
                <mat-icon>handshake</mat-icon>
                @if (!isMobile()) {
                  <span>Agreements</span>
                }
              </a>
            }
            <!--
            <a class="sidebar-messages" mat-list-item *ngIf="isMaster()"
              routerLink='/templates'
              routerLinkActive="sidebar-active-link">
              <mat-icon>web</mat-icon>
              <span *ngIf="!isMobile()">Templates</span>
            </a>-->
            @if (isAdmin()) {
              <a class="sidebar-messages" mat-list-item
                routerLink='/maintenance'
                routerLinkActive="sidebar-active-link">
                <mat-icon>engineering</mat-icon>
                @if (!isMobile()) {
                  <span>Maintenance</span>
                }
              </a>
            }
            <a class="sidebar-home" mat-list-item
              routerLink='/profile/Edit'
              routerLinkActive="sidebar-active-link">
              <mat-icon>settings</mat-icon>
              @if (!isMobile()) {
                <span>Profile</span>
              }
            </a>
            <!--
            <a class="sidebar-messages" mat-list-item *ngIf="isAdmin()"
              routerLink='/certification'
              routerLinkActive="sidebar-active-link">
              <mat-icon>school</mat-icon>
              <span class="sidebar-dashboard-text">Certification</span>
            </a>
            -->
          </mat-nav-list>
        }
        <div class="versionfooter">Version {{ version }}</div>
        <div class="versionfooter" [ngClass]="{'serverMismatch': serverVersion !== srvrVersion}">Srvr {{srvrVersion }}</div>
        <button mat-stroked-button (click)="releaseNotes()">Rel. Notes</button>
      </mat-sidenav>
      <mat-sidenav-content >
        <router-outlet ></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
}